'use client'
import React, { useState, useEffect } from 'react'
import LargeProjectCard from '@components/LargeProjectCard'
import SearchProjectMap from '@components/SearchProjectMap'
import MobileSearchProjectMap from '@components/MobileSearchProjectMap'
import MobileMapProjectCard from '@components/MobileMapProjectCard'
import { getFilteredProjects } from '@services/getFilteredProjects'
// import { getNewDevelopments } from '@services/getNewDevelopments'

// import { useSession } from 'next-auth/react'
import { saleTypes } from '@constants/saleTypes'

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

const NewDevelopmentResultCards = ({ searchParams, dictionary, lang = 'en' }) => {

    // const { data: session } = useSession()
    let userEmail = null

    // const [currency, setCurrencyType] = useState('thb')
    const [search, setSearch] = useState(searchParams)
    const [page, setPage] = useState(1);
    const [allPages, setAllPages] = useState(1);

    const [projects, setProjects] = useState([]);
    const [propertyCount, setPropertyCount] = useState(0);
    const [showMap, setShowMap] = useState(false)
    const [coordinates, setCoordinates] = useState([])
    const [hoveredProperty, setHoveredProperty] = useState(null)
    const [activeProperty, setActiveProperty] = useState({})
    const [activePropertyLat, setActivePropertyLat] = useState(13.732772)
    const [activePropertyLng, setActivePropertyLng] = useState(100.5801953)

    // if (session !== null) {
    //     userEmail = session?.user?.email
    // }

    const handleMouseEnter = (propertyId) => {
        // console.log(e)
        // console.log('hover ' + propertyId)
        setHoveredProperty(propertyId)
    };
    const handleMouseLeave = () => {
        // console.log('hover end')
        setHoveredProperty(null)
    };

    const handleSlideChange = (swiper) => {
        // Emit your event or perform actions when the active slide changes
        const activeSlideIndex = swiper.activeIndex;
        // console.log(`Active slide index: ${activeSlideIndex}`);
        let activePropertyId = swiper.slides[activeSlideIndex].id
        let activePropertyLat = swiper.slides[activeSlideIndex].dataset.latitude
        let activePropertyLng = swiper.slides[activeSlideIndex].dataset.longitude
        setActiveProperty(activePropertyId)
        setActivePropertyLat(activePropertyLat)
        setActivePropertyLng(activePropertyLng)

        // Emit an event or perform actions here
    };

    const getData = async () => {
        const result = await getFilteredProjects({
            // saleType: searchParams.saleType || saleTypes[lang][0].value,
            // bts: searchParams.bts || '',
            // district: searchParams.district || '',
            // location: searchParams.location || '',
            // project: searchParams.project || '',
            name: searchParams.name || '',
            category: searchParams.category || '',
            districts: searchParams.districts || '',
            // minBedrooms: searchParams.minBedrooms || '',
            // maxBedrooms: searchParams.maxBedrooms || '',
            // room: searchParams.room || '',
            // currency: searchParams.currency || 'thb',
            // minprice: searchParams.minprice || '',
            // maxprice: searchParams.maxprice || '',
            // petfriendly: searchParams.petfriendly || '',
            // seaview: searchParams.seaview || '',
            // beachfront: searchParams.beachfront || '',
            newdevelopment: true,
            map: searchParams.map || false,
            sort: searchParams.sort || 'datedesc',
            // limit: searchParams.limit || 10,
            page: page
        },
            userEmail
        )

        // console.log(result)

        if (page > 1) {
            setProjects((prev) => [...prev, ...result.projects])
        } else {
            setProjects(result.projects)
        }
        setAllPages(result.pages)
        setPropertyCount(result.count)
        setCoordinates(result.coordinates)
        if (result.projects.length > 0 && page == 1) {
            setActiveProperty(result.projects[0].id)
            setActivePropertyLat(Number(result.projects[0].latitude))
            setActivePropertyLng(Number(result.projects[0].longitude))
        }
    }

    useEffect(() => {
        setPage(1)
        setProjects([])
        setShowMap(searchParams.map)

        getData()
    }, [searchParams])

    useEffect(() => {
        getData()
    }, [page])

    return (
        <div className='md:w-full 2xl:w-10/12 flex md:flex-row flex-col flex-nowrap md:flex-wrap mx-auto md:px-3 px-0'>
            {showMap ? (
                <div className='w-full relative flex flex-row mx-auto'>
                    <div className='md:flex hidden md:h-[80vh] h-full min-w-[320px] pt-2 overflow-hidden overflow-y-scroll rounded-l-md border-forth border-[1px] border-solid flex-col items-center scrollable' >
                        {projects.map((project, index) => (
                            <div
                                key={project.id}
                                id={project.id}
                                // className='m-2'
                                onMouseEnter={() => (handleMouseEnter(project.id))}
                                onMouseLeave={handleMouseLeave}
                                className='mb-2'
                            >
                            <LargeProjectCard
                                newDevelopment={true}
                                dictionary={dictionary.card}
                                lang={lang}
                                project={project}
                                isLast={index === projects.length - 1}
                                imageWidth={320}
                                newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                            />
                            </div>
                        ))}
                    </div>
                    <div className='md:hidden block absolute bottom-0 left-0 right-0 z-[52]'>
                        <div className='sm:hidden block'>
                            <Swiper
                                slidesPerView={1}
                                onSlideChange={handleSlideChange}
                            >
                                {projects.map((project, index) => (
                                    <SwiperSlide
                                        key={project.id}
                                        id={project.id}
                                        data-latitude={Number(project.latitude)}
                                        data-longitude={Number(project.longitude)}
                                    >
                                        <MobileMapProjectCard
                                            newDevelopment={true}
                                            lang={lang}
                                            dictionary={dictionary.card}
                                            project={project}
                                            isLast={index === projects.length - 1}
                                            // imageWidth={imageWidth}
                                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    <div className='md:block hidden md:h-[80vh] h-full md:relative absolute w-full border-forth border-[1px] border-solid rounded-r-md overflow-hidden'>
                        <SearchProjectMap coordinates={coordinates} hoveredProperty={hoveredProperty} latitude={searchParams.latitude} longitude={searchParams.longitude} lang={lang} dictionary={dictionary} />
                    </div>
                    <div className='md:hidden block w-full h-full z-[51]'>
                        <MobileSearchProjectMap coordinates={coordinates} hoveredProperty={activeProperty} zoomControl={false} latitude={activePropertyLat} longitude={activePropertyLng} lang={lang} dictionary={dictionary} />
                    </div>
                </div>
            ) : (
                <>
                    {projects.map((project, index) => (
                        <div
                            key={project.id}
                            className='m-2'
                        >
                            <LargeProjectCard
                                newDevelopment={true}
                                dictionary={dictionary.card}
                                lang={lang}
                                project={project}
                                isLast={index === projects.length - 1}
                                imageWidth={320}
                                newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                            />
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default NewDevelopmentResultCards